import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorContext from '../../ErrorBoundary/contexts/ErrorContext';

class Home extends Component {
    render() {
        return (
            <ErrorContext.Consumer>
                {errVal => (
                        <div>
                            Home
                        </div>
                    )
                }
            </ErrorContext.Consumer>
        )
    }
}

export default Home;


